export default "__VITE_ASSET__82956294__"